<div class="container-fluid">
    <div class="row">
        <div class="col-md-5 col-sm-12">
            <div class="card">
                <div class="card-header">
                    <h1 class="title mb-0">Request Details</h1>
                </div>
                <div class="card-body">
                    <div class="row steps-action centered d-flex flex-column align-items-center justify-content-center">
                        <div class=" request-det-body body ">
                            <div class="card-body request-det">
                                <h1 class="mb-2 mt-4"> Customer Personal Details </h1>
                                <div class="data-card ">
                                    <div class="data-container mt-3 ">
                                        <div class="row">
                                            <div class="data col-6">
                                                <h6>Name</h6>
                                                <h4>{{request?.patient?.fullName}}</h4>
                                            </div>
                                            <div class="data col-6">
                                                <h6>National ID</h6>
                                                <h4>{{request?.patient?.nationalId}}</h4>
                                            </div>

                                        </div>
                                        <div class="row mt-3">
                                            <div class="data col-12">
                                                <h6>Mobile Number</h6>
                                                <h4>{{request?.patient?.phone}}</h4>
                                            </div>
                                        </div>


                                    </div>
                                </div>
                                <h1 class="mb-2"> Selected Area </h1>
                                <div class="address d-flex justify-content-around ">
                                    <div class="city">
                                        <label class="lab" for="">City</label>
                                        <h3 class="da">{{request?.patientAddressData?.city?.name}}</h3>
                                    </div>
                                    <hr>
                                    <div class="label">
                                        <label class="lab" for="area">Area</label>
                                        <h3 class="da">{{request?.patientAddressData?.area?.name}}</h3>
                                    </div>
                                </div>
                                <h1 class=""> Request Details </h1>
                                <!-- <div class="pharmacy">
                            <div class="address-card">
                                <div class="card-header">
                                    <div class="more-menu-trigger row d-flex justify-content-start pr-3 pl-3">
                                        <h3 >Seif</h3>
                                    </div>
                                </div>
                                <div class="card-body">
                                    <div class="row mt-2">
                                        <div class="col-md-12 ph-details">
                                            <label for="pharmacy">Address</label>
                                            <span id="pharmacy">'This is the address text that the patient has entered before.</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                         </div> -->
                                <div class="data-card">
                                    <div class="data-container mt-3">
                                        <div class="row">
                                            <div class="col-6">
                                                <div class="data">
                                                    <h6>Request Id</h6>
                                                    <h4>{{request?.id}}</h4>
                                                </div>
                                            </div>
                                            <div class="col-6">
                                                <div class="data">
                                                    <h6>Request Date</h6>
                                                    <h4>{{request?.creationDate | date}}</h4>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="row mt-3">
                                            <div class="col-6">
                                                <div class="data">
                                                    <h6>Request Type</h6>
                                                    <h4>{{request?.typeId == 1 ? 'Home Delivery': 'Pickup'}}</h4>
                                                </div>
                                            </div>
                                            <div class="col-6">
                                                <div class="data">
                                                    <h6>Program Name</h6>
                                                    <h4>{{request?.programName}}</h4>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row mt-3">
                                            <div class="col-12">
                                                <div class="data">
                                                    <h6>Channel</h6>
                                                    <h4>{{request?.channelId == 1 ? 'Call' : request?.channelId == 2 ? 'Application' : 'Pharmacy'}}</h4>
                                                </div>
                                            </div>
                                        </div>



                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-7 col-sm-12">
            <div class="card pharmacies">
                <ng-template [ngIf]="searchPharmacyStep == 1">
                    <div class="card-header">
                        <h2 class="title"> Nearest Pharmacies </h2>
                        <span>
                            You can select one from below recommendation or use the search to find another one.
                        </span>

                        <div class="search pr-3 mt-3 ">
                            <input class="search-p" type="text" name="search" id="src_txt"
                                placeholder="Type Pharmacy name..." (keyup.enter)="searchPharmacy($event.target.value)">
                            <i class="fa fa-search"></i>
                        </div>
                        <!-- <hr class="mb-4"> -->
                    </div>

                    <div class="pharmacy-list mt-2 p-3">

                        <div class="card small-card pointer" *ngFor="let pharmacy of pharmacyList"
                            (click)="onSelectPharmacy(pharmacy)">
                            <div class="small-card-body p-3">

                                <h3 class="m-0"> {{pharmacy.name}} - {{pharmacy.address | slice:0:15}}... </h3>
                                <span>
                                    <i class="icon-eye"></i>
                                </span>
                            </div>
                        </div>

                        <h3 class="text-center" *ngIf="pharmacyList.length == 0">There is no Available Pharmacies in
                            this area now</h3>


                    </div>

                </ng-template>
                <ng-template [ngIf]="searchPharmacyStep == 2">
                    <div class="card-header ph-details">
                        <div class="link d-flex align-items-center pointer" (click)="searchPharmacyStep = 1">
                            <span><i class="icon-left-arrow"></i></span>
                            <h5> Back To Pharmacies</h5>
                        </div>
                        <h2 class="title"> {{selectedPharmacy.name}} - {{selectedPharmacy.address}} </h2>
                        <span>
                        </span>
                    </div>
                    <div class="card-body pharmacy-det ">
                        <h1 class="mb-2 mt-4"> Pharmacy Details </h1>
                        <div class="data-card ">
                            <div class="data-container mt-3 ">
                                <h2>Location</h2>
                                <div class="row">
                                    <div class="data col-6">
                                        <h6>City</h6>
                                        <h4>{{selectedPharmacy?.city?.name}}</h4>
                                    </div>
                                    <div class="data col-6">
                                        <h6>Area</h6>
                                        <h4>{{selectedPharmacy?.area?.name}}</h4>
                                    </div>

                                </div>
                                <div class="row mt-3">
                                    <div class="data col-12">
                                        <h6>Address</h6>
                                        <h4>{{selectedPharmacy?.address}}</h4>
                                    </div>
                                </div>


                                <hr>
                                <h2>Contact Information</h2>
                                <div class="row">

                                    <div class="data col-6" *ngIf="selectedPharmacy?.phone">
                                        <h6>Pharmacy Number 1</h6>
                                        <h4>{{selectedPharmacy?.hotline}} <span class="pointer"
                                                (click)="copyToClipboard(selectedPharmacy?.hotline)"><i class="icon-copy"></i></span></h4>
                                    </div>
                                    <div class="data col-6">
                                        <h6>Pharmacy Number 2</h6>
                                        <h4>{{selectedPharmacy?.phone }} <span class="pointer"
                                                (click)="copyToClipboard(selectedPharmacy?.phone)"><i class="icon-copy"></i></span></h4>
                                    </div>
                                </div>


                                <div class="row step-footer mt-4 mb-5">
                                    <button type="submit" class="btn outline " (click)="searchPharmacyStep = 1"> Select Another Pharmacy </button>
                                    <button type="submit" class="btn btn-psp-primary  btn-round"
                                        [disabled]="selectedPharmacy.id == 0" (click)="confirmRouteToPharmacy()"> Pharmacy Confirmed Order!
                                    </button>


                                </div>
                            </div>
                        </div>

                    </div>
                </ng-template>
            </div>

        </div>
    </div>
</div>